import useFbAuth from "@hooks/useFbAuth"
import { useEffect, useState } from "react"

const VerifyMetaAuthPage = () => {
  const [loading, setLoading] = useState(true)
  const { handleVerifyFbToken } = useFbAuth()

  const extractToken = () => {
    const hash = window.location.hash.substring(1)
    const params = new URLSearchParams(hash)

    const accessToken = params.get("access_token")
    

    return accessToken
  }

  const accessToken = extractToken()

  useEffect(() => {
    if (accessToken) {
      handleVerifyFbToken(accessToken)
      // setLoading(false)
    }
  }, [accessToken])

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      padding: '2rem'
    }}>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <div style={{ textAlign: 'center' }}>
          <p>Thank you for your interest in our product.</p>
          <p>We will get back to you to onboard you as a user.</p>
          <p>Or you can book an onboarding meeting using this link:</p>
          <a href="https://calendly.com/ankitmahindru/intro-call" 
             target="_blank" 
             style={{
               display: 'block',
               marginTop: '1rem',
               color: '#007bff',
               textDecoration: 'underline'
             }}>
            https://calendly.com/ankitmahindru/intro-call
          </a>
        </div>
      )}
    </div>
  )
}

export default VerifyMetaAuthPage
